import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { navItems, siteInfo } from "@/mocks/site";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || !isHome;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/80"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 shrink-0" aria-label="511爆料首页">
          <span className="w-10 h-10 md:w-11 md:h-11 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
            511
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-lg md:text-xl font-bold tracking-wide transition-colors ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
            >
              {siteInfo.name}
            </span>
            <span
              className={`hidden sm:block text-[11px] mt-0.5 transition-colors ${
                solid ? "text-foreground-500" : "text-background-100/90"
              }`}
            >
              {siteInfo.slogan}
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 lg:gap-2" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `px-3 lg:px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                  solid
                    ? isActive
                      ? "text-primary-600 bg-primary-50"
                      : "text-foreground-700 hover:text-primary-600 hover:bg-primary-50/70"
                    : isActive
                      ? "text-background-50 bg-background-50/20"
                      : "text-background-100 hover:text-background-50 hover:bg-background-50/15"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/submit"
            className={`hidden sm:inline-flex items-center gap-1.5 px-4 md:px-5 py-2.5 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
              solid
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50 text-foreground-950 hover:bg-background-100"
            }`}
          >
            <i className="ri-flashlight-line"></i>
            我要爆料
          </Link>
          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className={`md:hidden w-10 h-10 rounded-md flex items-center justify-center transition-colors ${
              solid
                ? "text-foreground-900 hover:bg-background-200/70"
                : "text-background-50 hover:bg-background-50/15"
            }`}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200/80 px-4 py-3">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-sm font-medium transition-colors ${
                    isActive
                      ? "text-primary-600 bg-primary-50"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/submit"
              className="mt-1 px-4 py-3 rounded-md text-sm font-medium bg-primary-500 text-background-50 flex items-center gap-2"
            >
              <i className="ri-flashlight-line"></i>
              我要爆料
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}